import { AxiosRequestConfig } from "axios";
import storageX from "../storageCore/storageX";
import {
  STORAGE_KEY_ACCESS_TOKEN_KEYCLOAK,
  STORAGE_KEY_ACCESS_TOKEN_WSO2,
} from "../storageCore/constStorageKeys";

/**
 * Sempre aplica o token mais recente do storage.
 * Evita reutilizar Authorization antigo em defaults do Axios após o refresh.
 */
export function applyFreshAuthHeaders(req: AxiosRequestConfig): AxiosRequestConfig {
  const headers = (req.headers = req.headers || {});
  const common = (headers.common = headers.common || {});

  const wso2Token = storageX.whereKeyIs(STORAGE_KEY_ACCESS_TOKEN_WSO2).get();
  if (wso2Token) {
    const authorization = "Bearer " + wso2Token;
    common["Authorization"] = authorization;
    headers["Authorization"] = authorization;
  }

  const keycloakToken = storageX
    .whereKeyIs(STORAGE_KEY_ACCESS_TOKEN_KEYCLOAK)
    .get();
  if (keycloakToken) {
    const kcAuth = "Bearer " + keycloakToken;
    common["kc-auth"] = kcAuth;
    headers["kc-auth"] = kcAuth;
  }

  return req;
}
